import {Platform, StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      marginHorizontal: 24,
      marginTop: 16,
      borderRadius: 16,
      padding: 12,
      backgroundColor: colors.surface,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
    },
    productInfoView: {
      flexDirection: 'row',
    },
    productImage: {
      height: 74,
      width: 74,
      borderRadius: 8,
    },
    titleContainer: {
      marginLeft: 16,
      flex: 1,
      justifyContent: 'space-between',
    },
    priceContainer: {
      paddingHorizontal: 8,
      paddingVertical: 5,
      borderRadius: 8,
      backgroundColor: colors.backgroundMuted,
      alignSelf: 'flex-start',
    },
    shippingDetailRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: Platform.OS === 'web' ? 'flex-start' : 'space-between',
      marginTop: 8,
      gap: 8,
    },
    marginVertical16: {
      marginVertical: 16,
    },
    buyAgainButton: {
      borderWidth: 0,
      alignSelf: 'center',
    },
    buyAgainText: {
      marginVertical: 4,
      marginHorizontal: 25,
    },
  });

export default makeStyles;
